import { makeStyles } from '@material-ui/core';

// Логотип в развёрнутом сайдбаре: монограмма + словесный знак «wilde.tech».
// Цвета берутся из темы, а не задаются константой, — знак остаётся читаемым
// и в светлой, и в тёмной теме. Заменить на настоящий SVG, когда закончится
// регистрация товарного знака и появится файл от дизайнера.
const useStyles = makeStyles(theme => ({
  svg: {
    width: 'auto',
    height: 30,
  },
  box: {
    fill: theme.palette.primary.main,
  },
  glyph: {
    fill: theme.palette.getContrastText(theme.palette.primary.main),
  },
  word: {
    fill: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: 22,
    fontWeight: 500,
    letterSpacing: '-0.01em',
  },
  accent: {
    fill: theme.palette.primary.main,
  },
}));

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg className={classes.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190 48">
      <rect className={classes.box} width="48" height="48" rx="11" />
      <path
        className={classes.glyph}
        d="M9 15h5.4l3.3 12.6L21.3 15h5.4l3.6 12.6L33.6 15H39l-6 18h-5.7L24 21.6 20.7 33H15L9 15z"
      />
      <text x="60" y="31" className={classes.word}>
        wilde
        <tspan className={classes.accent}>.tech</tspan>
      </text>
    </svg>
  );
};
